import React from 'react';
import { AuthStateContext } from '../context/auth-context';

export const useAccountList = () => {
  const state = React.useContext(AuthStateContext);

  return Object.values(state.accounts) || [];
}